import Link from 'gatsby-link';
import styled from 'styled-components';

import { flex } from '../../../assets/styles/flex-grid';
import { FONT_SIZE } from '../../../assets/styles/font';
import { SCREEN } from '../../../assets/styles/constants';
// Atoms

export const MenuWrapper = styled.div`
	${flex};
	justify-content: flex-end;
	align-items: center;
	width: auto;
	position: relative;
	top: 2px;
`;

export const MenuLink = styled(Link)`
	color: #353944;
	text-decoration: none;
	${FONT_SIZE.BASE};
	white-space: nowrap;
	${SCREEN.SMALL} {
		font-size: 14px;
	}
	&.active {
		background-image: linear-gradient(180deg,#353944 80%,#353944 0);
	    background-repeat: repeat-x;
	    background-size: 1px 1px;
	    background-position: 0 98%;
	}
`;

export const MenuHamburgerWrapper = styled.div`
	display: none;

	${SCREEN.LARGE} {
		display: block;
		align-self: center;
	}
`;

export const MenuButtonLink = styled.a`
	background-color: transparent;
	text-decoration: none;
	color: #57AD5D;
	padding: 8px 0;
	border-radius: 4px;
	transition: background 0.8s;
	
	white-space: nowrap;
	&:hover {
		opacity: .7;
	}
	${SCREEN.SMALL} {
		padding: unset;
		font-size: 14px;
	}
`;

export const MenuSubMenuLink = styled.div`
	cursor: pointer;
	color: white;
	padding: 20px 0;
	display: flex;
	position: relative;
	white-space: nowrap;
	justify-content: space-between;
	${props => (props.bold ? 'font-weigh: bold' : 'font-weigh: normal')};
	transition: all ease-in-out 1s;

	&:after {
		position: absolute;
		bottom: 20px;
		content: '';
		width: 0px;
		height: 1px;
		display: block;
		background: #ffffff;
		transition: 0.5s;
	}

	&:hover {
		color: #ffffff;
	}
`;

export const MenuDropDownWrapper = styled.div`
	display: flex;
	position: absolute;
	flex-direction: column;
	background-color: #7F84FF;
	color: #ffffff;
	padding: 0 20px;
	width: 300px;
	top: 60px;
	right: calc(50% - 150px);
	z-index: 10;
	border-radius: 3px;
	transition: 0.3s;
	transform: scaleY(0);
	transform-origin: top;
`;

export const MenuLinkWrapper = styled.div`
	position: relative;
	height: 100%;
	margin-right: 30px;
	display: flex;
	align-items: center;

	&:hover ${MenuDropDownWrapper} {
		overflow: visible;
		transform: scaleY(1);
	}

	&:hover ${MenuLink} {
		color: #7F84FF;
	}

	${SCREEN.SMALL} {
		margin-right: 10px;
	}
`;

export const MenuBottomExtension = styled.div`
	position: absolute;
	height: 25px;
	width: 100%;
	bottom: -25px;
	left: 0;
`;

export const MenuArrowWrapper = styled.div`
	display: inline-block;
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	border-top: 6px solid black;
	border-radius: 4px;
	margin-left: 5px;
`;

export const MenuDropDownWrapperArrow = styled.div`
	top: -10px;
	left: calc(50% - 5px);
	position: absolute;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
	border-bottom: 10px solid #7F84FF;
`;

export const MenuSubLinkImage = styled.img`
	height: 22px;
`;

export const MenuSubLinkWrapper = styled(Link)`
	display: flex;
	cursor: pointer;
	justify-content: space-between;
	align-items: center;
	text-decoration: none;
	white-space: nowrap;
	&:hover ${MenuSubMenuLink} {
		::after {
			width: 100%;
		}
	}

	&:last-child {
		border-bottom: none;
	}
`;
